export const ZipCodeContent = {
  zipCodeTitle: 'Zip code',
  errorMsg: 'Your entry is invalid.',
};
